var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23.5,
    r: 23,
    fill: "#535353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.282 17.2238L32.4508 16.3926L24.7508 24.0926C23.7883 25.0551 22.1695 25.0551 21.207 24.0926L13.507 16.4363L12.6758 17.2676L18.407 22.9988L12.6758 28.7301L13.507 29.5613L19.2383 23.8301L20.3758 24.9676C21.0758 25.6676 21.9945 26.0613 22.957 26.0613C23.9195 26.0613 24.8383 25.6676 25.5383 24.9676L26.6758 23.8301L32.407 29.5613L33.2383 28.7301L27.507 22.9988L33.282 17.2238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6617 31.0496H14.3805C13.3742 31.0496 12.543 30.2184 12.543 29.2121V16.8746C12.543 15.8684 13.3742 15.0371 14.3805 15.0371H31.6617C32.668 15.0371 33.4992 15.8684 33.4992 16.8746V29.2121C33.4992 30.2184 32.668 31.0496 31.6617 31.0496ZM14.3367 16.2184C13.9867 16.2184 13.7242 16.4809 13.7242 16.8309V29.1684C13.7242 29.5184 13.9867 29.7809 14.3367 29.7809H31.618C31.968 29.7809 32.2305 29.5184 32.2305 29.1684V16.8309C32.2305 16.4809 31.968 16.2184 31.618 16.2184H14.3367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bdd35df33986a5f11e2fbe07c4fca7bc.svg";
export { ForwardRef as ReactComponent };